import { render } from "./Recommendations.vue?vue&type=template&id=cc39a428&ts=true"
import script from "./Recommendations.ts?vue&type=script&lang=ts&external"
export * from "./Recommendations.ts?vue&type=script&lang=ts&external"

import "./Recommendations.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__